export default {
  slack: {
    label: 'Slack',
    value: 'slack',
    imageId: 'slack-logo.svg',
  },
  dropbox: {
    label: 'Dropbox',
    value: 'dropbox',
    imageId: 'dropbox-logo.svg',
  },
  hubSpot: {
    label: 'HubSpot',
    value: 'hubSpot',
    imageId: 'hubspot-logo.svg',
  },
  xero: {
    label: 'Xero',
    value: 'xero',
    imageId: 'xero-logo.svg',
  },
  drive: {
    label: 'Drive',
    value: 'drive',
    imageId: 'drive-logo.svg',
  },
  quickBooks: {
    label: 'QuickBooks',
    value: 'quickBooks',
    imageId: 'quick-books-logo.svg',
  },
  box: {
    label: 'Box.com',
    value: 'box',
    imageId: 'box-logo.svg',
  },
  freshBooks: {
    label: 'FreshBooks',
    value: 'freshBooks',
    imageId: 'fresh-books-logo.svg',
  },
  oneDrive: {
    label: 'OneDrive',
    value: 'oneDrive',
    imageId: 'onedrive-logo.svg',
  },
  harvest: {
    label: 'Harvest',
    value: 'harvest',
    imageId: 'harvest-logo.svg',
  },
  sharePoint: {
    label: 'SharePoint',
    value: 'sharePoint',
    imageId: 'share-point-logo.svg',
  },
};
